/**
 * The date the current wording of the terms of use took effect, as an ISO date. It doubles as the
 * version stored on the user when they accept: the app blocks after login until the user's
 * accepted version equals this one, so bumping it with every change of the text is what makes
 * everyone accept the new wording — and forgetting to bump it is what silently would not.
 */
export const TERMS_VERSION = '2026-07-10';

/** The same date the way the terms text spells it: `10. 7. 2026`. */
export function termsEffectiveFrom(version: string = TERMS_VERSION): string {
  const [year, month, day] = version.split('-').map(Number);
  return `${day}. ${month}. ${year}`;
}
